<script setup lang="ts">
defineProps<{
  shouldShow: boolean
  disabled?: boolean
  addToScore: (score: number) => void
  cancelOrRemoveFromScore: () => void
  submit: () => void
}>()

const scorePadNumbers = [1, 2, 3, 4, 5, 6, 7, 8, 9]
</script>

<template>
  <div
    v-if="shouldShow"
    class="w-full p-1 grid grid-cols-3 grid-rows-4 gap-1 h-full my-auto portrait:h-2/5 landscape:w-1/3 relative"
    :class="{ 'pointer-events-none': disabled }"
  >
    <button
      v-for="(n, index) in scorePadNumbers"
      :key="index"
      v-touch:tap.prevent="() => addToScore(n)"
      class="sm:!text-4xl !font-bold h-full bg-primary text-primary-foreground rounded-sm"
    >
      {{ n }}
    </button>
    <button
      v-touch:tap.prevent="cancelOrRemoveFromScore"
      class="sm:!text-4xl !font-bold h-full bg-red-500 text-white rounded-sm"
    >
      <Icon name="tabler-backspace" />
    </button>
    <button
      v-touch:tap.prevent="() => addToScore(0)"
      class="sm:!text-4xl !font-bold h-full bg-primary text-primary-foreground rounded-sm"
    >
      0
    </button>
    <button
      v-touch:tap.prevent="submit"
      class="sm:!text-4xl !font-bold h-full bg-green-600 text-white rounded-sm"
    >
      <Icon name="tabler-send" />
    </button>
    <div
      v-if="$slots.overlay"
      class="absolute flex items-center justify-center inset-0 max-w-full bg-white/70 dark:bg-black/70 backdrop-blur-sm h-full overflow-hidden"
    >
      <slot name="overlay" />
    </div>
  </div>
</template>
